import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import MenuItem from "../../../types/menu/MenuItem";
import './Breadcrumb.css';
import { selectMenu } from "../../../redux/selectors/exportSelectorPaths";
import { faImage } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import i18n from "../../../i18n";
import Button from "../Button/Button";
import Asterisk from "../Asterisk/Asterisk";

interface BreadcrumbProps {
  profileTypeCode?: string;
}

function Breadcrumb(props: BreadcrumbProps): JSX.Element {
  const { t } = useTranslation('navigation');
  const menuState = useSelector(selectMenu);
  const [breadcrumbs, setBreadcrumbs] = useState<Array<MenuItem>>([])

  useEffect(() => {
    if (menuState.menu && menuState.menu.length > 0) {
      const bc = [] as Array<MenuItem>;
      let found = false;
      const search = (root: Array<MenuItem> | null | undefined) => {
        if (root && root.length > 0) {
          for (let i = 0; i < root.length; i++) {
            if (root[i].id === menuState.activeItem.id) {
              found = true;
              bc.push(root[i]);
              return;
            } else {
              search(root[i].subItems);
              if (found) {
                bc.push(root[i])
                return;
              }
            }
          }
        }
        return;
      };
      search(menuState.menu);
      setBreadcrumbs(bc.reverse());
    }
  }, [menuState.menu, menuState.activeItem, props]);

  return (
    <div className="breadcrumbs-container">
      {
        breadcrumbs.map((breadcrumb, index) => {
          return (
            <div key={index} className="flex flex-row">
              {index === 0 ?
                ""
                :
                <div className={"padding-left-5 padding-right-5"}>
                  &gt;
                </div>
              }
              <div className={breadcrumb.id === menuState.activeItem.id ? "current" : ""}>
                {t(breadcrumb.name)} {props.profileTypeCode === "AGS" && ["propertyDetails", "licensedLands", "licensedPonds", "unlicensedLands"].includes(breadcrumb.name) ? <Asterisk /> : <></>}
              </div>
            </div>
          )
        }
        )
      }
      {props.profileTypeCode === "AGS" && ["propertyDetails", "licensedLands", "licensedPonds", "unlicensedLands"].includes(menuState.activeItem.name) ? <div className="breadcrumb-button"><Button
        onClick={() => {
          window.open(i18n.language === "en" ? "/images/Aggregate Site EN.png" : "/images/Aggregate Site FR.png", "_blank", "noopener, noreferrer");
        }}
      ><FontAwesomeIcon icon={faImage} />{t("sample-image").toLocaleUpperCase()}
      </Button></div> : <></>}
    </div>
  );
}

export default Breadcrumb;